import { produce } from 'immer';
import { handleActions } from 'redux-actions';
import bulkActionsActions from '../actions/bulkActions';
const { bulkActionsOpenModal, bulkActionsCloseModal, bulkActionsAddAction, bulkActionsRemoveAction, bulkActionsSetTagsAdd, bulkActionsSetTagsRemove, bulkActionsSetReplyMessage, bulkActionsSetQueue, bulkActionsSetInternalNote, bulkActionsStart, bulkActionsCancel, bulkActionsProcessingEventStarted, bulkActionsProcessingEventFinished, bulkActionsCallApiFailed, } = bulkActionsActions;
const initialState = {
    isModalOpen: false,
    conversationIDs: [],
    selectedActionKeys: [],
    actionsData: {
        addInternalNote: {
            note: '',
        },
        addTag: {
            tags: [],
        },
        removeTag: {
            tags: [],
        },
        sendReply: {
            plainText: '',
            htmlText: '',
        },
        close: {},
        // claim: {},
        transferToQueue: {
            queue: null,
        },
        cancelCSAT: {},
    },
    meta: {
        asyncStatus: 'succeeded',
    },
};
export default handleActions({
    [bulkActionsOpenModal.toString()]: (state, action) => produce(state, (draftState) => {
        draftState.isModalOpen = true;
        draftState.conversationIDs = action.payload.conversationIDs;
        draftState.meta.location = action.payload.location;
    }),
    [bulkActionsCloseModal.toString()]: (state) => (Object.assign(Object.assign({}, initialState), { meta: Object.assign({}, state.meta) })),
    [bulkActionsAddAction.toString()]: (state, action) => produce(state, (draftState) => {
        draftState.selectedActionKeys.push(action.payload);
    }),
    [bulkActionsRemoveAction.toString()]: (state, action) => produce(state, (draftState) => {
        draftState.selectedActionKeys = draftState.selectedActionKeys.filter((key) => key !== action.payload);
    }),
    [bulkActionsSetTagsAdd.toString()]: (state, action) => produce(state, (draftState) => {
        draftState.actionsData.addTag.tags = action.payload;
    }),
    [bulkActionsSetTagsRemove.toString()]: (state, action) => produce(state, (draftState) => {
        draftState.actionsData.removeTag.tags = action.payload;
    }),
    [bulkActionsSetReplyMessage.toString()]: (state, action) => produce(state, (draftState) => {
        draftState.actionsData.sendReply = action.payload;
    }),
    [bulkActionsSetQueue.toString()]: (state, action) => produce(state, (draftState) => {
        draftState.actionsData.transferToQueue.queue = action.payload;
    }),
    [bulkActionsSetInternalNote.toString()]: (state, action) => produce(state, (draftState) => {
        draftState.actionsData.addInternalNote.note = action.payload;
    }),
    [bulkActionsStart.toString()]: (state) => produce(state, (draftState) => {
        draftState.meta.asyncStatus = 'loading';
    }),
    [bulkActionsCancel.toString()]: (state) => produce(state, (draftState) => {
        draftState.meta.asyncStatus = 'succeeded';
        draftState.meta.location = undefined;
    }),
    [bulkActionsProcessingEventStarted.toString()]: (state) => produce(state, (draftState) => {
        draftState.meta.asyncStatus = 'loading';
    }),
    [bulkActionsProcessingEventFinished.toString()]: (state) => produce(state, (draftState) => {
        draftState.meta.asyncStatus = 'succeeded';
        draftState.meta.location = undefined;
    }),
    [bulkActionsCallApiFailed.toString()]: (state) => produce(state, (draftState) => {
        draftState.meta.asyncStatus = 'failed';
        draftState.meta.location = undefined;
    }),
}, initialState);
